import { BiCheckCircle, BiInfoCircle, BiError } from 'react-icons/bi';

const SEVERITY_CONFIG = {
    positive: { Icon: BiCheckCircle, colour: '#10b981', bg: '#ecfdf5' },
    info:     { Icon: BiInfoCircle,  colour: '#3b82f6', bg: '#eff6ff' },
    warning:  { Icon: BiError,       colour: '#f59e0b', bg: '#fffbeb' },
};

const CATEGORY_COLOURS = {
    margin:     '#8b5cf6',
    cost:       '#ef4444',
    revenue:    '#10b981',
    scheduling: '#3b82f6',
    general:    '#64748b',
};

export default function InsightCard({ title, body, category, severity, metric }) {
    const { Icon, colour, bg } = SEVERITY_CONFIG[severity] ?? SEVERITY_CONFIG.info;
    const cat = (category || 'general').toLowerCase();
    const pillBg = CATEGORY_COLOURS[cat] ?? CATEGORY_COLOURS.general;

    return (
        <div className="h-100 d-flex flex-column" style={{
            borderRadius: 12,
            border: '1px solid var(--bs-border-color, #e5e7eb)',
            overflow: 'hidden',
        }}>
            {/* Coloured top strip */}
            <div style={{ height: 4, backgroundColor: colour }} />
            <div className="p-3 d-flex flex-column flex-grow-1" style={{ background: 'var(--bs-body-bg, #fff)' }}>
                {/* Header: icon + title */}
                <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle"
                         style={{ width: 32, height: 32, backgroundColor: bg }}>
                        <Icon size={16} style={{ color: colour }} />
                    </div>
                    <div className="fw-semibold" style={{ fontSize: '0.85rem', lineHeight: 1.3 }}>{title}</div>
                </div>

                {/* Key metric (if provided) */}
                {metric && (
                    <div className="fw-bold mb-2" style={{ fontSize: '1.3rem', color: colour }}>{metric}</div>
                )}

                {/* Body */}
                <p className="text-muted small mb-auto" style={{ lineHeight: 1.5, fontSize: '0.8rem' }}>{body}</p>

                {/* Category pill */}
                <div className="mt-2">
                    <span className="badge" style={{
                        background: `${pillBg}18`,
                        color: pillBg,
                        fontSize: '0.65rem',
                        fontWeight: 600,
                        letterSpacing: '0.03em',
                        textTransform: 'uppercase',
                    }}>
                        {category}
                    </span>
                </div>
            </div>
        </div>
    );
}
